var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57363 13.7574C4.03439 13.7574 1.16531 10.9384 1.16531 7.45547C1.16531 3.9725 4.03439 1.14788 7.57363 1.14788C11.1129 1.14788 13.9825 3.9725 13.9825 7.45547C13.9825 10.9384 11.1129 13.7574 7.57363 13.7574ZM17.8301 17.021L13.1829 12.4464C14.3995 11.1241 15.1473 9.37982 15.1473 7.45547C15.1473 3.33667 11.7566 0 7.57363 0C3.39069 0 0 3.33667 0 7.45547C0 11.5686 3.39069 14.9053 7.57363 14.9053C9.38094 14.9053 11.0386 14.2808 12.3406 13.2398L17.0063 17.8312C17.2342 18.0563 17.6028 18.0563 17.8301 17.8312C18.058 17.6118 18.058 17.246 17.8301 17.021Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon2);
export default __webpack_public_path__ + "static/media/SearchIcon_2.cd8cd4198d0e0e9f40c0a6dbe97d3857.svg";
export { ForwardRef as ReactComponent };